import React, { useState, useEffect } from 'react'
import axios from 'axios';
import {getCsrfToken} from '../../commons/authenticityToken';
import LoadingOverlay from 'react-loading-overlay';

const Index = (props) => {
  axios.defaults.headers.common['X-CSRF-Token'] = getCsrfToken();

  const [ mParts, setMParts ] = useState([]);

  const [errorMessage, setErrorMessage] = useState("");

  // ロード系
  const [isLoading, setIsLoading]  = useState<Boolean>(false);

  // 初回ロード
  useEffect(() =>{
    setIsLoading(true);
    axios.get(
      '/api/internal/parts/required_category_parts', {})
      .then(function (response) {
        setMParts(response.data.m_parts);
      })
      .catch(error => {

      }).finally(() => {
        setIsLoading(false);
      });
  },[])

  function changeHearingId(m_part_id, value){
    setMParts(mParts.map((m_part) => (m_part.id === m_part_id ? {...m_part, institution_gooco_hearing_id: value} : m_part)));
  }

  // 登録・更新処理
  function submitGoocoHearingId(){
    setIsLoading(true);
    axios.post(
      '/api/internal/institution_hearing_ids/update', {m_parts: mParts})
      .then(function (response) {
        location.href = ("/parts/index");
      })
      .catch(error => {
        setErrorMessage(error.response.data.message);
        window.scrollTo({left: 0, top: 0, behavior: "smooth"});
    }).finally(() => {
      setIsLoading(false);
    });
  }

  return(
    <LoadingOverlay active={isLoading} spinner text="Loading...">
    { errorMessage && 
      <div className="alert alert-danger alert-dismissible" role="alert">
        <button type="button" className="close" data-dismiss="alert" aria-label="閉じる">
          <span aria-hidden="true">×</span>
        </button>
        { errorMessage }
      </div>
    }
      <div className="row">
        <div className="col-xs-12 col-sm-12 col-md-12 col-lg-12">
          <div className="form-group">
            {/* テンプレート一覧 */}
            <div className="form-group">
              <h3>必須カテゴリ質問GooCo先確認ID設定</h3>
              <div className="text-left col-md-12 col-sm-12 col-xs-12">
                  必須カテゴリに設定されている質問のGooCo先確認IDを店舗単位に設定できます。<br/>
                  未設定の場合は、共通のGooCo先確認IDが使用されます。
              </div>
              <table id="notice_table" className="table table-bordered">
                <thead>
                  <tr className="success">
                    <th className="col-md-2 col-sm-2 col-xs-2 text-center">質問タイトル</th>
                    <th className="col-md-2 col-sm-2 col-xs-2 text-center">共通のGooCo先確認ID</th>
                    <th className="col-md-8 col-sm-8 col-xs-8 text-center">店舗のGooCo先確認ID</th>
                  </tr>
                </thead>
                <tbody>
                  {
                    mParts.map((m_part, idx) => {
                    return(
                      <tr key={`m_part_${m_part.id}`}>
                        <td>{m_part.name}</td>
                        <td>{m_part.gooco_hearing_id}</td>
                        <td>
                          <input 
                            type="text"
                            id={`m_part_${m_part.id}`} 
                            className="form-control col-lg-1" 
                            placeholder="GooCo先確認ID"
                            value={m_part.institution_gooco_hearing_id}
                            disabled={props.is_reader}
                            onChange={(e) => changeHearingId(m_part.id, e.target.value)}
                          />
                        </td>
                      </tr>
                      )
                    })
                  }
                </tbody>
              </table>
            </div>
              {/* ボタン類 */}
              <div>
                  <div className="actions mt40">
                      <a className="btn btn-primary pull-left m5" href="/parts/index">戻る</a>
                      <button className="btn btn-primary pull-right m5" disabled={props.is_reader} onClick={() => submitGoocoHearingId()}>
                        更新する
                      </button>
                  </div>
              </div>
          </div>
      </div>
    </div>
  </LoadingOverlay >
  )
}
export default Index;